// Need to use the React-specific entry point to allow generating React hooks
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithDecryption } from "../baseQueryWithEncryption";

// Define a service using a base URL and expected endpoints
export const chatApi = createApi({
  reducerPath: "chatApi",
  tagTypes: ["chat", "chatMessage"],

  baseQuery: baseQueryWithDecryption(
    `${import.meta.env.VITE_CHAT_API_URL}/api/usage`,
  ),
  endpoints: (builder) => ({
    getAiCompanyConfig: builder.query({
      query: () => ({
        url: `/company-config/my-config`,
        method: "GET",
      }),
    }),
    createCompanyConfig: builder.mutation({
      query: (body) => ({
        url: `/company-config`,
        method: "POST",
        body,
      }),
    }),
    updateCompanyConfig: builder.mutation({
      query: (body) => ({
        url: `/company-config/api-keys`,
        method: "PUT",
        body,
      }),
    }),
    // deletePlanCategory: builder.mutation({
    // 	query: (id) => ({
    // 		url: `/plan-category/${id}`,
    // 		method: "DELETE",
    // 	}),
    // }),
  }),
});

export const {
  useGetAiCompanyConfigQuery,
  useCreateCompanyConfigMutation,
  useUpdateCompanyConfigMutation,
} = chatApi;
